import { useTranslation } from 'react-i18next'; // Import the translation hook for multi-language support
import { useDispatch } from 'react-redux'; // Import the useDispatch hook to dispatch actions to Redux store
import { useState } from 'react';
import {
    CreatelistofContractorEmployeeContract,
} from '../../../../reduxToolkit/Contractor/ContractorApi';
import { toast } from 'react-toastify';
import { errorMsg } from '../../../../Apis/functions';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const AddEmployeesModalApp = ({ onHide, selectedId, setModified, show }) => {
    const { t } = useTranslation(); // Initialize the translation function
    const dispatch = useDispatch(); // Get the dispatch function to dispatch actions to Redux
    const [selectedEmployee, setSelectedEmployee] = useState([]);

    // Function to handle adding a user to the selection list
    const handleAdd = (items) => {
        const all_items = items?.map((item) => item?.id); // Get the IDs of all selected items
        if (all_items) {
            let data = {
                userIds: all_items,
                contractId: selectedId,
            };
            dispatch(CreatelistofContractorEmployeeContract(data)).then(
                ({
                    payload: {
                        data: { success, code },
                    },
                }) => {
                    if (success === true) {
                        toast.success(t('has_been_added_successfully')); // Show success message
                        setModified(true);
                        onHide();
                    } else errorMsg(code);
                },
            );
        }
    };

    // Return the necessary variables and functions for use in other parts of the app
    return {
        t, // Translation
        handleAdd,
        selectedEmployee,
        setSelectedEmployee,
        id: selectedId,
    };
};

export default AddEmployeesModalApp; // Export the component to be used in other parts of the app
